/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SetCompanyApiRateLimitingEnabledRequest
 */
export interface SetCompanyApiRateLimitingEnabledRequest {
  /**
   *
   * @type {boolean}
   * @memberof SetCompanyApiRateLimitingEnabledRequest
   */
  enabled: boolean;
}

/**
 * Check if a given object implements the SetCompanyApiRateLimitingEnabledRequest interface.
 */
export function instanceOfSetCompanyApiRateLimitingEnabledRequest(
  value: object,
): value is SetCompanyApiRateLimitingEnabledRequest {
  if (!("enabled" in value) || value["enabled"] === undefined) return false;
  return true;
}

export function SetCompanyApiRateLimitingEnabledRequestFromJSON(
  json: any,
): SetCompanyApiRateLimitingEnabledRequest {
  return SetCompanyApiRateLimitingEnabledRequestFromJSONTyped(json, false);
}

export function SetCompanyApiRateLimitingEnabledRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SetCompanyApiRateLimitingEnabledRequest {
  if (json == null) {
    return json;
  }
  return {
    enabled: json["enabled"],
  };
}

export function SetCompanyApiRateLimitingEnabledRequestToJSON(
  json: any,
): SetCompanyApiRateLimitingEnabledRequest {
  return SetCompanyApiRateLimitingEnabledRequestToJSONTyped(json, false);
}

export function SetCompanyApiRateLimitingEnabledRequestToJSONTyped(
  value?: SetCompanyApiRateLimitingEnabledRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    enabled: value["enabled"],
  };
}
